export enum LogoTypes {
  Logo = 'logo',
  ExternalLogo = 'external-logo',
  HeroImage = 'hero-image',
  SecondaryExternalLogo = 'secondary-external-logo',
}
